import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { useId } from 'react';

type Props = {
  labelsToValue: { label: string; value: string }[];
};

export const ModalDescription = (props: Props) => {
  const id = useId();
  const row = (itemName: string, value: string) => {
    const itemId = `item-${id}-${itemName}`;
    return (
      <Stack key={itemId} direction="row" aria-labelledby={itemId}>
        <Stack flex={0.15} id={itemId}>
          <Typography variant="body2">{itemName}:&nbsp;</Typography>
        </Stack>
        <Stack flex={1}>
          <Typography style={{ fontWeight: 500 }} variant="body2">
            {value}
          </Typography>
        </Stack>
      </Stack>
    );
  };

  return (
    <Stack rowGap={theme.spacing['2']}>
      {props.labelsToValue.map(({ label, value }) => row(label, value))}
    </Stack>
  );
};
